'use client'

import type { ForgotPasswordFormProps } from '@maestro/commerce-blocks/components/forgot-password/forgot-password.types'

import { useTranslations } from 'next-intl'

import { useForgotPassword } from '@maestro/commerce-blocks/components/forgot-password/batons/use-forgot-password'
import { TrackingButton } from '@maestro/commerce-blocks/components/tracking-button'
import { useForm } from '@maestro/commerce-blocks/hooks/use-form'
import { requestPasswordResetFormSchema } from '@maestro/commerce-blocks/schemas'
import { requestPasswordReset } from '@maestro/commerce-blocks/server/actions/auth'
import { ErrorMessage } from '@pearlconvert/ui/components/error-message'
import { Fieldset } from '@pearlconvert/ui/components/fieldset'
import { Input } from '@pearlconvert/ui/components/input'

export default function ForgotPasswordForm({
  cmsBlock,
  onSuccess: onSuccessProp,
}: ForgotPasswordFormProps) {
  const t = useTranslations('commerce-blocks')
  const { handleResetSuccess } = useForgotPassword()

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitDisabled },
    formT,
  } = useForm({
    schema: requestPasswordResetFormSchema,
    submitAction: requestPasswordReset,
    onSuccess: (_response, submittedData) => {
      handleResetSuccess(submittedData?.email)
      onSuccessProp?.()
    },
  })

  return (
    <div className="forgot-password">
      {cmsBlock}
      <form onSubmit={handleSubmit}>
        <Fieldset>
          <Input
            id="forgot-password-email"
            {...register('email')}
            type="email"
            inputSize="large"
            label={formT('email.label')}
            placeholder={formT('email.placeholder')}
            autoComplete="email"
            error={errors.email?.message}
          />
          <ErrorMessage errors={errors}>
            {errors.root?.serverError?.message}
          </ErrorMessage>
          <TrackingButton
            location="Forgot Password"
            type="primary"
            buttonType="submit"
            disabled={isSubmitDisabled}
            isLoading={isSubmitting}
          >
            {t('auth.forgot-password.title')}
          </TrackingButton>
        </Fieldset>
      </form>
    </div>
  )
}
